export default __webpack_public_path__ + "static/media/s5.d3429057.jpg";